export default __webpack_public_path__ + "static/media/AtomsAndCompounds _10.c85ecaf5.png";